import { render, staticRenderFns } from "./JollyGoComponent.vue?vue&type=template&id=af69d4f0&"
import script from "./JollyGoComponent.vue?vue&type=script&lang=js&"
export * from "./JollyGoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports